/*
 * 20 languages plus English, every one held at 100%.
 *
 * The list has moved twice. All 74 were shipped on 2026-07-28 because BNI, who run chapters in
 * roughly 70 countries, had asked whether GrowthSync translates, and breadth reads as a sales
 * asset. Tom cut it back to 20 on 2026-07-29: 75 locale files is 17MB, and `src/i18n/request.ts`
 * loads them with a dynamic import(`../messages/${locale}.json`), so the bundler compiles a chunk
 * for every one of them into the page-rendering function. That is weight on every cold start, paid
 * by every user, to serve languages nobody had selected.
 *
 * These 20 cover the large business populations and the languages BNI actually asked about. If a
 * language goes back on this list, its file has to be at 100% first: `npm run check:translations`
 * fails the build on a missing key, a broken placeholder, a translated product name, a mixed
 * register, or any untranslated English.
 */
// Supported locales
export const locales = [
  "en", // English
  "es", // Spanish
  "fr", // French
  "de", // German
  "it", // Italian
  "pt", // Portuguese
  "nl", // Dutch
  "pl", // Polish
  "ru", // Russian
  "uk", // Ukrainian
  "cs", // Czech
  "ro", // Romanian
  "tr", // Turkish
  "ar", // Arabic
  "ja", // Japanese
  "zh-CN", // Chinese Simplified
  "ko", // Korean
  "hi", // Hindi
  "id", // Indonesian
  "vi", // Vietnamese
  "sv", // Swedish
] as const;

export type Locale = (typeof locales)[number];

export const defaultLocale: Locale = "en";

// Locales that read right-to-left. Single source of truth for `dir` on the
// document — anything that needs to know RTL-ness should import this.
export const rtlLocales: readonly Locale[] = ["ar"];

export function isRtlLocale(locale: Locale): boolean {
  return (rtlLocales as readonly string[]).includes(locale);
}

